export default "__VITE_ASSET__B9$XF1by__"